import { isPaletteKey, type PaletteKey } from '../palette';

export type Pixel = PaletteKey | null;

/**
 * Parses a text grid: one row per line, leading/trailing indentation and blank edge lines ignored,
 * `.` (or space) = transparent, every other char must be a palette key.
 */
export function parseGrid(src: string, where = 'grid'): { w: number; h: number; pixels: Pixel[] } {
  const rows = src
    .split('\n')
    .map((r) => r.trim())
    .filter((r) => r.length > 0);
  const h = rows.length;
  const w = rows[0]?.length ?? 0;
  const pixels: Pixel[] = [];
  rows.forEach((row, y) => {
    if (row.length !== w) throw new Error(`${where}: row ${y} is ${row.length} wide, expected ${w}\n  "${row}"`);
    for (let x = 0; x < w; x++) {
      const ch = row[x] as string;
      if (ch === '.' || ch === ' ') {
        pixels.push(null);
      } else if (isPaletteKey(ch)) {
        pixels.push(ch);
      } else {
        throw new Error(`${where}: unknown colour '${ch}' at ${x},${y}`);
      }
    }
  });
  return { w, h, pixels };
}
